import type { Slicer } from '@swf/core/store';

import type { SportsEventTypeInfoState } from './types';

export const selectors = (slice: Slicer<SportsEventTypeInfoState>) => ({
  eventTypeInfo: () => slice((state) => state.eventTypeInfo),
  isLoading: () => slice((state) => state.isLoading),
  hasPreloaded: () => slice((state) => state.hasPreloaded)
});
